export class TypePassation {

    tpt_id: string;
    tpt_ref: string;
    tpt_libelle: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.tpt_id         = data['tpt_id'] ? data['tpt_id'] : null;
        this.tpt_ref        = data['tpt_ref'] ? data['tpt_ref'] : null;
        this.tpt_libelle    = data['tpt_libelle'] ? data['tpt_libelle'] : null;
    }

}
